import { ReactNode } from "react";

type Props = {
  children: ReactNode;
};

export function InputGroup({ children }: Props) {
  return <div className="py-2">{children}</div>;
}
